/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Aggregator } from '../models/aggregator';
import { Aggregators } from '../models/aggregators';
import { aggregatorsAggregatorIdGet } from '../fn/aggregators/aggregators-aggregator-id-get';
import { AggregatorsAggregatorIdGet$Params } from '../fn/aggregators/aggregators-aggregator-id-get';
import { aggregatorsGet } from '../fn/aggregators/aggregators-get';
import { AggregatorsGet$Params } from '../fn/aggregators/aggregators-get';
import { aggregatorStoreStatusGet } from '../fn/aggregators/aggregator-store-status-get';
import { AggregatorStoreStatusGet$Params } from '../fn/aggregators/aggregator-store-status-get';
import { StoreAggregatorStatusResponse } from '../models/store-aggregator-status-response';

@Injectable({ providedIn: 'root' })
export class AggregatorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `aggregatorsAggregatorIdGet()` */
  static readonly AggregatorsAggregatorIdGetPath = '/aggregators/{aggregatorId}';

  /**
   * Gets a specified aggregator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsAggregatorIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsAggregatorIdGet$Response(params: AggregatorsAggregatorIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Aggregator>> {
    return aggregatorsAggregatorIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specified aggregator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsAggregatorIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsAggregatorIdGet(params: AggregatorsAggregatorIdGet$Params, context?: HttpContext): Observable<Aggregator> {
    return this.aggregatorsAggregatorIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Aggregator>): Aggregator => r.body)
    );
  }

  /** Path part for operation `aggregatorsGet()` */
  static readonly AggregatorsGetPath = '/aggregators';

  /**
   * Gets all aggregators.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGet$Response(params?: AggregatorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Aggregators>> {
    return aggregatorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all aggregators.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGet(params?: AggregatorsGet$Params, context?: HttpContext): Observable<Aggregators> {
    return this.aggregatorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Aggregators>): Aggregators => r.body)
    );
  }

  /** Path part for operation `aggregatorStoreStatusGet()` */
  static readonly AggregatorStoreStatusGetPath = '/stores/{storeId}/status/{aggregatorId}';

  /**
   * Get a store aggregator status.
   *
   * Get a store aggregator status
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorStoreStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorStoreStatusGet$Response(params: AggregatorStoreStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorStatusResponse>> {
    return aggregatorStoreStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a store aggregator status.
   *
   * Get a store aggregator status
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorStoreStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorStoreStatusGet(params: AggregatorStoreStatusGet$Params, context?: HttpContext): Observable<StoreAggregatorStatusResponse> {
    return this.aggregatorStoreStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreAggregatorStatusResponse>): StoreAggregatorStatusResponse => r.body)
    );
  }

}
